import { Injectable } from "@angular/core";
import { AuthenticationService } from "../../api/api/authentication.service";
import { Observable, catchError, of, switchMap, take, throwError } from "rxjs";
import { AuthLoginResponse, AuthRefreshTokenResponse, RefreshTokenRequest } from "./auth.type";
import { TokenStorageService } from "../services/token-storage.service";
import { TokenService } from "../services/token.service";
import { LocalStorageService } from "../services/local-storage.service";


@Injectable()
export class AuthService {

    get accessToken(): string | null {
        return this._tokenStorageService.getAccessToken()
    }

    /**
     * Check if an access token is stored
     *
     * TODO - check token expiry too. Does the refresh token logic take care of this?
     * const isAccessTokenExpired = this._tokenService.checkTokenExpiration();
     * return this.accessToken !== null && isAccessTokenExpired !== null && !isAccessTokenExpired;
     */
    get isAuthenticated(): boolean {
        return this.accessToken !== null;
    }

    /**
     * Constructor
     */
    constructor(
        private _authService: AuthenticationService,
        private _tokenService: TokenService,
        private _tokenStorageService: TokenStorageService,
        private _localStorageService: LocalStorageService,
    ) {}

    /**
     * Sign in
     *
     * @param credentials
     */
    authenticate(credentials: { email: string; password: string }): Observable<AuthLoginResponse> {
        return this._authService.authenticateUser(credentials).pipe(
            take(1),
            switchMap((response: AuthLoginResponse) => {

                // Return a new observable with the response
                return of(response)
            }),
        )
    }

    /**
     * 
     * @param refreshTokenRequest 
     * @returns 
     */
    refreshTokenLocalStorageUpdate(refreshTokenRequest: RefreshTokenRequest): Promise<AuthRefreshTokenResponse> {
        return new Promise<AuthRefreshTokenResponse>(
            resolve =>{
                this._authService.refreshToken(refreshTokenRequest).pipe(
                    take(1),
                    catchError(err => {
                        // another layer of checking
                        if (this._tokenService.checkRefreshTokenExpiration()) {
                            this._tokenService.removeTokensAndOpenSessionDialog('session_expired');
                            return throwError(() => err);
                        }
                        return throwError(() => new Error('/refresh-token endpoint dummy error due to racing condition but refresh token is not expired'));
                    })
                ).subscribe((response: AuthRefreshTokenResponse) => {
                    const accessToken = response.accessToken
                    const refreshToken = response.refreshToken
                    const refreshTokenExpiry = response.refreshTokenExpiry
        
                    this._tokenStorageService.saveAccessToken(accessToken)
                    this._tokenStorageService.saveRefreshToken(refreshToken, refreshTokenExpiry)
                    resolve(response)
                })
            }
        )
    }
}
